import { useEffect, useState } from 'react'
import { Button, Group, List, Modal, Stack, Text, Textarea } from '@mantine/core'
import type { AcaoDeWaf } from '@/api/waf'
import { descreverAcao } from './acoesDoModulo'

/** A mesma régua de `waf_codigo/emergencia.JUSTIFICATIVA_MINIMA`. */
export const JUSTIFICATIVA_MINIMA = 30

/**
 * O atalho de emergência (spec 2026-10-14 D8): grava na AWS agora e abre o
 * pedido que leva a mudança ao código. O modal diz os três efeitos antes do
 * clique, porque a deriva que ele cria é de propósito e fica visível.
 */
export function ModalEmergencia({
  opened, acao, stage, justificativaInicial, enviando, erro, onClose, onConfirmar,
}: {
  opened: boolean
  acao: AcaoDeWaf | null
  stage: string
  justificativaInicial: string
  enviando: boolean
  erro: string | null
  onClose: () => void
  onConfirmar: (justificativa: string) => void
}) {
  const [justificativa, setJustificativa] = useState(justificativaInicial)
  useEffect(() => { if (opened) setJustificativa(justificativaInicial) }, [opened, justificativaInicial])
  const faltam = JUSTIFICATIVA_MINIMA - justificativa.trim().length

  return (
    <Modal opened={opened} onClose={onClose} title="Aplicar agora (emergência)" size="lg">
      <Stack gap="sm">
        {acao && <Text size="sm" fw={600}>{descreverAcao(acao)}</Text>}
        <List size="sm" spacing={4}>
          <List.Item>Grava na AWS agora, sem esperar o pedido.</List.Item>
          <List.Item>
            Abre na hora o pedido de codificação no stage{' '}
            <Text span ff="monospace" size="sm">{stage}</Text>, que você confirma e um DevOps
            Sênior aprova.
          </List.Item>
          <List.Item>
            A AWS fica diferente do código até esse pedido concluir, e a tela mostra essa deriva.
          </List.Item>
        </List>
        <Text size="sm" c="dimmed">
          Pedido em andamento no stage que ainda não chegou ao repositório é cancelado; um MR
          aberto ou um apply em andamento faz a emergência esperar.
        </Text>
        <Textarea
          label="Justificativa"
          description="Por que não dá para esperar o pedido. Vai para a GMUD, a trilha e o pedido."
          minRows={3}
          value={justificativa}
          onChange={e => setJustificativa(e.currentTarget.value)}
          error={faltam > 0 && justificativa.length > 0 ? `faltam ${faltam} caracteres` : undefined}
        />
        {erro && <Text size="sm" c="red">{erro}</Text>}
        <Group>
          <Button
            color="red"
            size="xs"
            disabled={!acao || faltam > 0}
            loading={enviando}
            onClick={() => onConfirmar(justificativa.trim())}
          >
            Aplicar na AWS e abrir o pedido
          </Button>
          <Button size="xs" variant="default" onClick={onClose}>Cancelar</Button>
        </Group>
      </Stack>
    </Modal>
  )
}
